import produce from 'immer';
import {
  Engagement,
  EngagementActionType,
} from 'modules/redux/states/engagement/types';
import { EngagementAction } from '../constants';

function detailsReducer(state: Engagement, action: EngagementActionType) {
  switch (action.type) {
    case EngagementAction.GET_DETAILS_FAILURE:
      return produce(state, (draftState: Engagement) => {
        draftState.details.actionId = null;
        draftState.details.isError = action.error;
        draftState.details.isLoading = false;
        draftState.details.data = null;
      });

    case EngagementAction.GET_DETAILS_STARTED:
      return produce(state, (draftState: Engagement) => {
        draftState.details.actionId = action.actionId;
        draftState.details.isError = false;
        draftState.details.isLoading = action.controller || true;
        draftState.details.data = null;
      });

    case EngagementAction.GET_DETAILS_SUCCESS:
      return produce(state, (draftState: Engagement) => {
        draftState.details.actionId = null;
        draftState.details.isError = false;
        draftState.details.isLoading = false;
        draftState.details.data = action.data;
      });

    default:
      return state;
  }
}

export default detailsReducer;
